import React from "react";
import "./ChannelButton.css";

const ChannelButton = React.memo(({ channel, vehicle, onClick, isActive }) => {
  return (
    <button 
      className={`channel-button ${isActive ? "channel-button-active" : ""}`} 
      onClick={onClick} 
      type="button"
    >
      {channel.name}
    </button>
  );
}, (prevProps, nextProps) => {
  // Only re-render if active state or channel changes
  return prevProps.isActive === nextProps.isActive && 
         prevProps.channel.number === nextProps.channel.number;
});

export default ChannelButton;
